import { OrderNoteType } from '../pages/delivery/graphql/types/DeliveryTaskOrderType';

/**
 * 从订单备注对象中获取当前语言对应的备注内容
 *
 * 逻辑：
 * 1. 根据当前语言和基础语言构建偏好语言列表（如 'en-US' -> ['en-us', 'en']）
 * 2. 从 orderNoteTranslations 中查找匹配的翻译
 * 3. 如果找到匹配的翻译，返回 translateNote
 * 4. 如果没有找到，返回原始的 note
 *
 * @param orderNote 订单备注对象
 * @param currentLanguage 当前语言代码（如 'en-US', 'zh-CN'）
 * @returns 当前语言对应的备注内容，如果没有则返回原始note，已trim处理
 */
export function getOrderNoteContent(
    orderNote: OrderNoteType | null | undefined,
    currentLanguage: string
): string {
    if (!orderNote) {
        return '';
    }

    const language = (currentLanguage || '').toLowerCase();
    const baseLanguage = language.split('-')[0];
    const preferredLanguages = Array.from(
        new Set([language, baseLanguage].filter(Boolean))
    );

    const translations = orderNote.orderNoteTranslations || [];
    const matchedTranslation = translations.find(translation =>
        preferredLanguages.includes((translation.lang || '').toLowerCase())
    );

    return (matchedTranslation?.translateNote || orderNote.note || '').trim();
}

